(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["foh-header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var header = document.querySelector('[data-foh-header]');
    if (!header) return;
    var menuToggle = header.querySelector('[data-menu-toggle]');
    var drawer = header.querySelector('[data-mobile-menu]');
    menuToggle && menuToggle.addEventListener('click', function () {
      var open = drawer.toggleAttribute('data-open');
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    });
    var close = drawer && drawer.querySelector('[data-menu-close]');
    close && close.addEventListener('click', function () { drawer.removeAttribute('data-open'); drawer.setAttribute('aria-hidden', 'true'); });
    var searchToggle = header.querySelector('[data-search-toggle]');
    var search = header.querySelector('[data-search]');
    searchToggle && searchToggle.addEventListener('click', function () { var open = search.toggleAttribute('data-open'); searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foh-hero-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var slider = document.querySelector('[data-slider]');
    if (!slider || slider.dataset.count <= 1) return;
    var slides = slider.querySelectorAll('[data-slide]');
    var viewport = slider.querySelector('[data-slider-viewport]');
    var dots = slider.querySelectorAll('[data-slider-dot]');
    var index = 0, timer = null;
    function go(i) {
      index = (i + slides.length) % slides.length;
      viewport.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (d) { d.classList.toggle('active', +d.dataset.index === index); });
    }
    var next = slider.querySelector('[data-slider-next]');
    var prev = slider.querySelector('[data-slider-prev]');
    next && next.addEventListener('click', function () { go(index + 1); reset(); });
    prev && prev.addEventListener('click', function () { go(index - 1); reset(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.index); reset(); }); });
    function start() { if (slider.dataset.autoplay === 'true') { timer = setInterval(function () { go(index + 1); }, +slider.dataset.interval || 5000); } }
    function reset() { clearInterval(timer); start(); }
    if (dots.length) dots[0].classList.add('active');
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
